import { combineReducers } from "redux";
import sidebarReducer from "./sidebarSlice";
import profileReducer from "../../Components/Views/SettingsModule/services/profileReducer";
import authReducer from "../../Components/Views/AuthModule/services/authReducer";
import { baseQuery } from "../../services/baseQuery";

const rootReducer = combineReducers({
  auth: authReducer,
  sidebar: sidebarReducer,
  profile: profileReducer,
  [baseQuery.reducerPath]: baseQuery.reducer,
});

export default rootReducer;
